// extracted by mini-css-extract-plugin
module.exports = {"background":"main-background-module--background--3tvnB","foreground":"main-background-module--foreground--2TsM6"};